export default __webpack_public_path__ + "static/media/NTEX CLASS-7 EXAM PATTERN 2025.163c9264.pdf";